<template>
  <div class="wrapper">
    <div class="row">
      <div class="col col-12 col-md-4 name">
        <div class="form-group">
          <c-input
            v-model="value.institution"
            floating-label="Название учебного заведения"
            :clearable="true"
            :max-length="255"
            :required="error && error.institution"
            :required-message="error && error.institution"
          />
        </div>
      </div>
      <div class="col col-12 col-md-4 specialization">
        <div class="form-group">
          <c-input
            v-model="value.specialization"
            floating-label="Специальность"
            :clearable="true"
            :max-length="255"
            :required="error && error.specialization"
            :required-message="error && error.specialization"
          />
        </div>
      </div>
      <div class="col col-2 sm d-none d-md-block d-lg-none remove-md">
        <c-button
          v-if="canRemove"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Удалить',
            placement: 'top',
          }"
          size="iconic"
          icon="trash"
          @click="$emit('remove')"
        />
      </div>
      <div class="col col-12 col-md-2 years">
        <div class="form-group">
          <div class="c-input-label">Год поступления — окончания</div>
          <div class="years__wrapper">
            <div class="years__from">
              <c-input
                v-model="value.from"
                :clearable="true"
                :max-length="4"
                type="price-number"
                placeholder="0000"
                :fractional-length="0"
                :invalid="error && (error.from || error.period)"
              />
            </div>
            <span class="years__divider">–</span>
            <div class="years__to">
              <c-input
                v-model="value.to"
                :clearable="true"
                :max-length="4"
                type="price-number"
                placeholder="0000"
                :fractional-length="0"
                :invalid="error && (error.to || error.period)"
              />
            </div>
          </div>
          <error-feedback
            v-if="error && (error.period || error.from || error.to)"
            :text="error && (error.period || error.from || error.to)"
          />
        </div>
      </div>
      <div class="col col-12 d-md-none">
        <div class="d-flex justify-content-end">
          <c-button
            v-if="canRemove"
            v-b-popover.html="{
              container: '#app',
              trigger: 'hover blur',
              content: 'Удалить',
              placement: 'top',
            }"
            size="small"
            label="Удалить"
            icon="trash"
            @click="$emit('remove')"
          />
        </div>
      </div>
      <div class="col col-1 remove lg d-none d-lg-block">
        <c-button
          v-if="canRemove"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Удалить',
            placement: 'top',
          }"
          size="iconic"
          icon="trash"
          @click="$emit('remove')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CInput from "@/components/controls2/Input";
import CButton from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";

export default {
  components: { CInput, CButton, ErrorFeedback },
  props: ["value", "error", "canRemove"],
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";
@import "~@/assets/styles/grid.scss";

.wrapper {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #dfe4ef;

  .years {
    padding-top: 6px;

    .c-input-label {
      white-space: nowrap;
    }

    &__wrapper {
      display: flex;
    }

    &__from,
    &__to {
      flex-grow: 1;
      max-width: 70px;
    }

    &__divider {
      flex-shrink: 0;
      padding: 0 12px;
    }

    @include beforeBootstrapMd {
      &__from,
      &__to {
        max-width: none;
      }
    }

    @include bootstrapLg {
      min-width: 180px !important;
      max-width: 200px !important;
    }
  }

  .remove {
    padding-top: 20px;
  }

  .remove-md {
    padding-top: 18px;
  }

  @include bootstrapMd {
    padding-bottom: 0;
    border-bottom: none;
    margin-bottom: -24px;

    @include gridGenerator(10);
  }

  @include bootstrapLg {
    @include gridGenerator(12);
  }
}
</style>
